import React, { Component } from "react";
import BaksetItem from "../components/BasketItem";
import { Button, Spinner, Modal } from "react-bootstrap";
import { MagicSpinner } from "react-spinners-kit";
import { CheckBoxComponent } from "@syncfusion/ej2-react-buttons";
import { Redirect } from "react-router-dom";
import brokerTitle from "../assets/brokerTitle.png";
import { toast } from "react-toastify";

export default class BrokersContent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      mobile: "",
      brokersData: [],
      brokersList: [],
      editedId: null,
      buttonDisabled: false,
      anyBorkerVisible: false,
      currentBrokerId: "",
      currentBrokerName: "",
      archiveBroker: false,
      apiHasError: false,
      buttonDisabledArchive: true,
      isLoading: false,
      buttonSpinner: false,
    };

    this.getBrokersName = this.getBrokersName.bind(this);
    this.scrolltobottom = this.scrolltobottom.bind(this);
    this.saveBrokers = this.saveBrokers.bind(this);
    this.deleteApi = this.deleteApi.bind(this);
  }

  componentDidMount() {
    if (!this.props.inModal) {
      this.props.onBrokerLoad();
    }

    this.setState({ isLoading: true });
    let data = {
      mobile: localStorage.getItem("mobile"),
      token: localStorage.getItem("token"),
    };

    fetch("/api/brokerList", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((resultt) => {
        this.setState({ isLoading: false });
        if (resultt.status === 200) {
          this.setState({ brokersData: resultt.result });

          let anyBorkerVisible = false;
          resultt.result.forEach(function (entry) {
            if (entry.status === 2) anyBorkerVisible = true;
          });
          this.setState({ anyBorkerVisible: anyBorkerVisible });

          this.getBrokersName();
        } else {
          this.setState({ apiHasError: true });
        }
      })
      .catch((error) => {
        this.setState({ isLoading: false });
        this.setState({ apiHasError: true });
      });
  }

  getBrokersName() {
    let data = {
      mobile: localStorage.getItem("mobile"),
      token: localStorage.getItem("token"),
      word: "",
    };

    fetch("/api/searchBroker", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((resultt) => {
        if (resultt.status === 200) {
          this.setState({ brokersList: resultt.result });
        } else {
          this.setState({ apiHasError: true });
        }
      });
  }

  deleteItem(id, name, balance, lable) {
    if (lable !== null && lable !== "") {
      name = name + " (" + lable + ")";
    }
    if (this.props.inModal || (!this.props.inModal && balance > 0)) {
      this.setState({
        currentBrokerId: id,
        currentBrokerName: name,
        ModalShow: true,
        archiveBroker: true,
        buttonDisabledArchive: true,
      });
    } else {
      this.deleteApi(id);
    }
  }

  deleteApi(id) {
    try {
      if (id < 0) {
        let broker = this.state.brokersData.slice();
        let i = 0;
        let index = -1;
        broker.forEach(function (entry) {
          if (entry.id === id) {
            index = i;
          }
          i++;
        });
        if (index !== -1) {
          broker.splice(index, 1);
          this.setState({ brokersData: broker });
        }
        if (this.state.ModalShow) this.hideModal();

        // if (this.props.inModal) this.props.hideModal();
        return;
      }

      let data = {
        mobile: localStorage.getItem("mobile"),
        token: localStorage.getItem("token"),
        broker_id: id,
      };

      this.setState({ buttonDisabledArchive: true });
      fetch("/api/deleteBroker", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((result) => {
          if (result.status >= 200 && result.status < 300) {
            let broker = this.state.brokersData.slice();
            let i = 0;
            let index = -1;
            broker.forEach(function (entry) {
              if (entry.id === id) {
                index = i;
              }
              i++;
            });
            if (index !== -1) {
              broker.splice(index, 1);
              this.setState({ brokersData: broker });
            }

            if (this.state.ModalShow) this.hideModal();

            if (this.props.inModal) this.props.hideModal();

            toast.success("حذف با موفقیت انجام شد", {
              position: toast.POSITION.BOTTOM_LEFT,
              hideProgressBar: true,
              autoClose: 8000,
              toastClassName: "toast",
            });
          } else {
            if (this.state.ModalShow) this.hideModal();

            if (this.props.inModal) this.props.hideModal();
            toast.error(result.message, {
              position: toast.POSITION.BOTTOM_LEFT,
              hideProgressBar: true,
              autoClose: 8000,
              toastClassName: "toast",
            });
          }
          this.setState({ buttonDisabledArchive: false });
        });
    } catch (error) {}
  }

  editItem(id, name, des) {
    let dess = null;
    if (des !== null && des !== "") dess = des;
    const broker = this.state.brokersData.slice(); //copy the array
    broker.forEach(function (entry) {
      if (entry.id === id) {
        entry.lable = dess;
        entry.Edited = true;
      }
    });

    this.setState({ brokersData: broker });
  }

  addItem(id, name, des) {
    let dess = null;
    if (des !== null && des !== "") dess = des;

    let lowsetId = -1;
    this.state.brokersData.forEach(function (entry) {
      if (entry.id < lowsetId) {
        lowsetId = entry.id;
      }
    });

    this.setState((previousState) => ({
      brokersData: [
        ...previousState.brokersData,
        {
          id: lowsetId,
          broker_id: id,
          broker_name: name,
          lable: dess,
          Created: true,
          status: 2,
        },
      ],
      anyBorkerVisible: true,
    }));
    setTimeout(this.scrolltobottom, 10);
  }

  nextClick() {
    this.saveBrokers();
  }

  backClick() {
    this.props.onBrokerBack();
  }

  showHideItem(id, status) {
    let broker = this.state.brokersData.slice(); //copy the array
    let anyBorkerVisible = false;
    broker.forEach(function (entry) {
      if (entry.id === id) {
        let s;
        if (status) s = 2;
        else s = 3;
        entry.status = s;
        entry.Edited = true;
      }
      if (entry.status === 2) anyBorkerVisible = true;
    });

    this.setState({ brokersData: broker, anyBorkerVisible: anyBorkerVisible });
  }

  scrolltobottom() {
    this.itemscontainer.scrollTop = this.itemscontainer.scrollHeight + 200;
  }

  editedCall(id) {
    this.setState({ editedId: id });
  }

  saveBrokers() {
    try {
      let list = [];

      this.state.brokersData.forEach(function (entry) {
        if (entry.Created !== undefined) {
          var d = {
            lable: entry.lable,
            broker_id: entry.broker_id,
            status: entry.status,
            type: "insert",
          };
          list.push(d);
        } else if (entry.Edited !== undefined) {
          var dd = {
            lable: entry.lable,
            user_broker_id: entry.id,
            status: entry.status,
            type: "update",
          };
          list.push(dd);
        }
      });

      if (list.length === 0 && !this.props.inModal) {
        this.props.onBrokerNext();
        return;
      } else if (list.length === 0 && this.props.inModal) {
        this.props.hideModal();
        return;
      }

      let data = {
        mobile: localStorage.getItem("mobile"),
        token: localStorage.getItem("token"),
        list: list,
      };

      this.setState({ buttonDisabled: true, buttonSpinner: true });
      fetch("/api/addUserBroker", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((result) => {
          if (result.status >= 200 && result.status < 300) {
            if (this.props.inModal) this.props.hideModal();
            else {
              if (this.state.brokersData.length > 0) {
                this.props.onBrokerNext();
                return;
              } else {
                alert("حداقل یک کارگزاری باید ثبت شود");
              }
            }
          } else {
            this.setState({ apiHasError: true });
          }
          this.setState({ buttonDisabled: false, buttonSpinner: false });
        });
    } catch (error) {
      this.setState({ buttonDisabled: false, buttonSpinner: false });
    }
  }

  hideModal() {
    this.setState({ ModalShow: false });
  }

  archiveBrokerYES() {
    this.deleteApi(this.state.currentBrokerId);
  }

  check1Change() {
    try {
      if (this.check1.checked) {
        this.setState({ buttonDisabledArchive: false });
      } else {
        this.setState({ buttonDisabledArchive: true });
      }
    } catch (error) {}
  }

  componentStatusChanged(edited) {
    try {
      if (this.props.inModal) {
        if (edited) {
          this.setState({ buttonDisabled: true });
        } else {
          this.setState({ buttonDisabled: false });
        }
      }
    } catch (error) {}
  }

  render() {
    return (
      <div
        style={
          this.props.inModal
            ? {
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
                width: "100%",
              }
            : {
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
                maxWidth: "450px",
                width: "97%",
              }
        }
      >
        {!this.props.inModal && (
          <div
            style={{
              marginTop: "0px",
              marginBottom: "0px",
              textAlign: "center",
              justifyContent: "center",
              alignItems: "center",
              alignContent: "center",
              display: "flex",
              padding: "0px",
              flexDirection: "column",
            }}
          >
            <img src={brokerTitle} alt="logo" className="stepsLogo" />
            <div style={{ fontSize: "20px" }}>
              اطلاعات مربوط به کارگزاری های خود را وارد کنید
            </div>
            {/* <div style={{fontSize:'13px',color:'var(--gray1)'}} >لطفاً حداقل یک کارگزاری را انتخاب کنید، سپس دکمه مرحله بعدی را بزنید</div> */}
            {!this.props.inModal && (
              <div
                style={{
                  fontSize: "14px",
                  color: "var(--gray1)",
                  marginTop: "10px",
                }}
              >
                حداقل یک کارگزاری باید وجود داشته باشد
              </div>
            )}
            {this.props.inModal && (
              <div
                style={{
                  fontSize: "14px",
                  color: "var(--gray1)",
                  marginTop: "10px",
                }}
              >
                حداقل یک کارگزاری با حالت نمایش باید وجود داشته باشد
              </div>
            )}
          </div>
        )}

        {this.props.inModal && (
          <div
            style={{
              marginTop: "0px",
              marginBottom: "0px",
              minHeight: "70px",
              textAlign: "center",
              justifyContent: "center",
              alignItems: "center",
              alignContent: "center",
              display: "flex",
              padding: "0px",
              flexDirection: "column",
            }}
          >
            <div style={{ fontSize: "20px" }}>لیست کارگزاری ها</div>
            <div
              style={{
                fontSize: "14px",
                color: "var(--gray1)",
                marginTop: "10px",
              }}
            >
              حداقل یک کارگزاری با حالت نمایش باید وجود داشته باشد
            </div>
          </div>
        )}

        <div
          className={
            this.props.inModal
              ? "basketItemsContainer-modal"
              : "basketItemsContainer"
          }
        >
          <div
            ref={(scope) => (this.itemscontainer = scope)}
            className={
              this.props.inModal ? "itemscontainer-modal" : "itemscontainer"
            }
          >
            {this.state.brokersData.length > 0 &&
              this.state.brokersData.map((item, i) => (
                <BaksetItem
                  key={i}
                  componentStatus={this.componentStatusChanged.bind(this)}
                  type="default"
                  status={item.status === 2 ? true : false}
                  showHideEnable={this.props.inModal ? true : false}
                  showHide={this.showHideItem.bind(this)}
                  desHolder="توضیحات"
                  editedStatus={
                    this.state.editedId !== null &&
                    this.state.editedId === item.id
                      ? true
                      : false
                  }
                  editedCall={this.editedCall.bind(this, item.id)}
                  itemId={item.id}
                  description={
                    item.lable !== null && item.lable !== "" ? item.lable : ""
                  }
                  userBrokerList={this.state.brokersData}
                  listData={this.state.brokersList}
                  showShare={false}
                  nameHolder="نام کارگزاری"
                  name={item.broker_name}
                  delete={this.deleteItem.bind(
                    this,
                    item.id,
                    item.broker_name,
                    item.balance,
                    item.lable
                  )}
                  editItem={this.editItem.bind(this)}
                />
              ))}
            {this.state.isLoading && (
              <MagicSpinner size={70} color="var(--green1)" loading={true} />
            )}
          </div>
          <div style={{ width: "100%" }}>
            <BaksetItem
              componentStatus={this.componentStatusChanged.bind(this)}
              type="new"
              editedCall={this.editedCall.bind(this, 0)}
              editedStatus={
                this.state.editedId !== null && this.state.editedId === 0
                  ? true
                  : false
              }
              desHolder="توضیحات"
              userBrokerList={this.state.brokersData}
              listData={this.state.brokersList}
              showShare={false}
              defaultText="افزودن یک کارگزاری جدید"
              nameHolder="نام کارگزاری"
              addItem={this.addItem.bind(this)}
            />
          </div>
        </div>

        {this.props.inModal && (
          <div className="popupButtons">
            <Button
              variant="primary"
              style={{ fontSize: "14px", margin: "5px" }}
              disabled={
                this.state.buttonDisabled ||
                this.state.brokersData.length === 0 ||
                (this.state.brokersData.length > 0 &&
                  !this.state.anyBorkerVisible)
                  ? true
                  : false
              }
              onClick={this.saveBrokers}
            >
              {this.state.buttonSpinner && (
                <Spinner className="spinnerStyle" animation="border" />
              )}
              {!this.state.buttonSpinner && <div>ذخیره</div>}
            </Button>
            <Button
              variant="danger"
              style={{ fontSize: "14px", margin: "5px" }}
              onClick={this.props.hideModal}
            >
              بستن
            </Button>
          </div>
        )}

        {this.props.showLogo && (
          <div style={{ width: "100%" }}>
            <div className="footerStyle">
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginTop: "30px",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    width: "10px",
                    height: "10px",
                    margin: "0px 7px",
                    backgroundColor: "var(--green1)",
                    borderRadius: "50%",
                  }}
                />
                <div
                  style={{
                    width: "8px",
                    height: "8px",
                    margin: "0px 7px",
                    backgroundColor: "var(--gray3)",
                    borderRadius: "50%",
                  }}
                />
                <div
                  style={{
                    width: "8px",
                    height: "8px",
                    margin: "0px 7px",
                    backgroundColor: "var(--gray3)",
                    borderRadius: "50%",
                  }}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginTop: "20px",
                  marginBottom: "30px",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <Button
                  variant="danger"
                  onClick={this.backClick.bind(this)}
                  style={{ minWidth: "150px", fontSize: "14px" }}
                >
                  خروج
                </Button>
                <Button
                  variant="primary"
                  style={{ minWidth: "150px", fontSize: "14px" }}
                  disabled={
                    this.state.buttonDisabled ||
                    this.state.brokersData.length === 0 ||
                    (this.state.brokersData.length > 0 &&
                      !this.state.anyBorkerVisible)
                      ? true
                      : false
                  }
                  onClick={this.nextClick.bind(this)}
                >
                  {this.state.buttonSpinner && (
                    <Spinner className="spinnerStyle" animation="border" />
                  )}
                  {!this.state.buttonSpinner && <div>مرحله بعد</div>}
                </Button>
              </div>
            </div>
          </div>
        )}

        <Modal
          show={this.state.ModalShow}
          animation={true}
          onHide={this.hideModal.bind(this)}
          centered
          // backdrop={true}
        >
          {this.state.archiveBroker && (
            <div className="popup">
              {/* <div style={{marginBottom:'30px'}}>
                                    آیا مطمئن به حذف کارگزاری "{this.state.currentBrokerName}" هستید؟
                                </div> */}
              <div style={{ marginBottom: "10px" }}>
                آیا مطمئن به حذف کارگزاری هستید؟
              </div>
              <div
                style={{
                  fontSize: "15px",
                  fontWeight: "bold",
                  marginBottom: "25px",
                  color: "var(--textcolor1)",
                }}
              >
                &nbsp;"&nbsp;{this.state.currentBrokerName}&nbsp;"&nbsp;
              </div>
              <CheckBoxComponent
                className="checkBoxContainer"
                label="اطلاعات کارگزاری بعد از حذف غیرقابل برگشت است و شرایط را قبول دارم"
                ref={(scope) => (this.check1 = scope)}
                change={this.check1Change.bind(this)}
                enableRtl="true"
              />
              <div className="popupButtons">
                <Button
                  variant="primary"
                  disabled={this.state.buttonDisabledArchive}
                  style={{ fontSize: "14px", margin: "5px" }}
                  onClick={this.archiveBrokerYES.bind(this)}
                >
                  بله
                </Button>
                <Button
                  variant="danger"
                  style={{ fontSize: "14px", margin: "5px" }}
                  onClick={this.hideModal.bind(this)}
                >
                  خیر
                </Button>
              </div>
            </div>
          )}
        </Modal>
        {this.state.apiHasError && <Redirect to="/Login" />}
      </div>
    );
  }
}
